import { render, staticRenderFns } from "./AzureWarning.vue?vue&type=template&id=729e671d&scoped=true&"
import script from "./AzureWarning.vue?vue&type=script&lang=js&"
export * from "./AzureWarning.vue?vue&type=script&lang=js&"
import style0 from "./AzureWarning.vue?vue&type=style&index=0&id=729e671d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e671d",
  null
  
)

export default component.exports